import moment from "moment";
import AirDatepicker from "air-datepicker";
import localeUk from 'air-datepicker/locale/uk';
import localeRu from 'air-datepicker/locale/ru';

export class Clients {
    constructor({ insuranceForm, clientForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._clientForm = clientForm;
        this._state = state;

        this._lang = $('html').attr('lang');

        this.$clientsSelect = $(this.$insuranceForm).find('#people_count');
        this.$clientsWrapper = $(this.$insuranceForm).find('.clients_wrapper');

        this._init();
    }

    _init() {
        this._state.clients.push({
            id: 1,
            index: 0,
            born_date: moment('2000-01-12'),
            mz_insurance_sum: 0,
        });
        this._state.people_count = 1;
        
        $(this.$clientsSelect).selectize({
            onItemAdd: this._selectQuantity.bind(this),
        });

        $(this.$clientsWrapper).on('keyup', this._updateDate.bind(this));
        $(this.$clientsWrapper).on('change', this._updateDate.bind(this));

        this._generateClientFields();
        this._initSelectize();
    }

    _selectQuantity(value) {
        const qty = +value;
        const clientsCount = this._state.people_count;
        const clients = this._state.clients;

        if (qty === clientsCount || qty > 4) return;

        if (clientsCount > qty) {
            const difference = Math.abs(clientsCount - qty);
            
            for (let i = 0; i < difference; i++) {
                clients.pop();
                this._state.people_count = this._state.people_count - 1;
            }
        }

        if (clientsCount < qty) {
            const difference = Math.abs(qty - clientsCount);

            for (let i = 0; i < difference; i++) {
                clients.push({
                    id: this._state.people_count + 1,
                    index: this._state.people_count,
                    born_date:  moment('2000-01-12'),
                    mz_insurance_sum: 0,
                });

                this._state.people_count = this._state.people_count + 1
            }
        }

        this._generateClientFields();
        this._initSelectize();
    }

    _generateClientFields() {
        let elements = '';
        this._state.clients.forEach((client) => {
            elements += this._clientForm.getTemplate(client);
        });

        $(this.$clientsWrapper).html(elements);

        //Инициализировать datepicker
        this._initDatepicker();
    }

    _initDatepicker() {
        this._state.clients.forEach(client => {
            new AirDatepicker(`#client-${client.id}`, {
                locale: this._lang === 'ru-ua' ? localeRu : localeUk,
                autoClose: true,
                dateFormat: 'yyyy-MM-dd',
                startDate: moment('2000-01-12'),
                maxDate: moment().subtract(18, 'years'),
                onSelect: ({date, formattedDate, datepicker}) => {
                    const clientId = client.id;
                    const foundUser = this._state.clients.find(client => client.id === +clientId);
                    foundUser.born_date = moment(formattedDate);
                },
            });
        });
    }

    _initSelectize() {
        $('.mzInsuranceSelect').selectize({
            onItemAdd: (value, element) => {
                const clientId = $(element).closest('.checkout_form_row').data('client');
                const client = this._state.clients.find(client => client.id === +clientId);
                client.mz_insurance_sum = value;
            }
        });
    }

    _updateDate(event) {
        const element = event.target;
        const clientId = $(element).closest('.checkout_form_row').data('client');
        const client = this._state.clients.find(client => client.id === +clientId);

        client.born_date = moment($(element).val());
    }


}